module.exports = __webpack_public_path__ + "static/img/tutorial-tool-attraction-4.90ea7cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-tool-attraction-4.jpg
// module id = yJA0
// module chunks = 3